import type { SlideProps } from "@/engine/app/offsite-config";

/** Slide 12 (Slide12Ueberleitung) ist der Workshop-Einstieg. */
const WORKSHOP_BRIDGE_SLIDE = 16;

export function Slide01Titel({ onJump }: SlideProps) {
  const goTo = (slideNumber: number) => {
    if (onJump) onJump(slideNumber);
  };

  return (
    <div className="deck-root" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 420,
          height: 420,
          top: "-80px",
          right: "-120px",
          background: "var(--svo-blau)",
          opacity: 0.35,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 320,
          height: 320,
          bottom: "-80px",
          left: "10%",
          background: "var(--svo-gruen)",
          opacity: 0.18,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1" style={{ color: "var(--svo-blau)" }}>
          Offsite Netzkundenmanagement · September 2026
        </div>
        <h1 className="deck-title rise rise-2" style={{ color: "#fff" }}>
          Digitalisierung <br />
          <span className="accent">und KI im Netz</span>
        </h1>
        <p
          className="deck-sub rise rise-3"
          style={{ color: "rgba(255,255,255,0.78)" }}
        >
          Weniger Nacharbeit, kürzere Durchlaufzeiten — und heute probiert ihr
          selbst aus, wie das geht.
        </p>
      </header>

      <div className="deck-flow">
        <div className="chapter rise rise-4">
          <div className="chapter-num">01</div>
          <div className="chapter-title">
            KI <span className="alt">verstehen</span>
          </div>
          <div className="chapter-desc">
            Was heute schon automatisch läuft — und was KI wirklich ist.
          </div>
          <div className="chapter-foot">
            <div className="chapter-meta">Grundlagen</div>
            <div className="chapter-arrow">→</div>
          </div>
        </div>

        <button
          type="button"
          className="chapter-bridge chapter-bridge-clickable rise rise-5"
          onClick={() => goTo(WORKSHOP_BRIDGE_SLIDE)}
          title={`Springe zu Folie ${WORKSHOP_BRIDGE_SLIDE} — Workshop-Bridge`}
        >
          <div className="chapter-bridge-pill">
            <span className="chapter-bridge-icon">⚡</span>
            <div className="chapter-bridge-text">
              <span className="chapter-bridge-eyebrow">Interaktiver Workshop</span>
              <span className="chapter-bridge-title">
                Ihr sagt der KI, was das Netz braucht — sie baut es.
              </span>
              <span className="chapter-bridge-action">→ Folie {WORKSHOP_BRIDGE_SLIDE}</span>
            </div>
          </div>
        </button>

        <button
          type="button"
          className="chapter chapter-clickable rise rise-5"
          onClick={() => goTo(18)}
          title="Springe zu Folie 18"
        >
          <div className="chapter-num">02</div>
          <div className="chapter-title">
            SVO OS <span className="alt">erleben</span>
          </div>
          <div className="chapter-desc">
            Live-Demo: was mit KI gebaute Software heute schon kann.
          </div>
          <div className="chapter-foot">
            <div className="chapter-meta">Live-Demo · Folie 18</div>
            <div className="chapter-arrow">→</div>
          </div>
        </button>

        <button
          type="button"
          className="chapter-bridge chapter-bridge-clickable rise rise-6"
          onClick={() => goTo(20)}
          title="Springe zu Folie 20 — Reveal"
        >
          <div className="chapter-bridge-pill">
            <span className="chapter-bridge-icon">✨</span>
            <div className="chapter-bridge-text">
              <span className="chapter-bridge-eyebrow">Reveal</span>
              <span className="chapter-bridge-title">
                Was die KI aus euren Ideen gebaut hat.
              </span>
              <span className="chapter-bridge-action">→ Folie 20</span>
            </div>
          </div>
        </button>

        <button
          type="button"
          className="chapter chapter-clickable rise rise-6"
          onClick={() => goTo(23)}
          title="Springe zu Folie 23"
        >
          <div className="chapter-num">03</div>
          <div className="chapter-title">
            Eure <span className="alt">Themen</span>
          </div>
          <div className="chapter-desc">
            Ergebnisse, Sorgen, Nöte, Anträge — offene Runde.
          </div>
          <div className="chapter-foot">
            <div className="chapter-meta">Austausch · Folie 23</div>
            <div className="chapter-arrow">→</div>
          </div>
        </button>
      </div>

      <footer className="deck-foot" style={{ color: "rgba(255,255,255,0.55)" }}>
        <span>Viktor Lüders · IT Requirements Manager</span>
        <span>SVO · Celle · Uelzen</span>
      </footer>
    </div>
  );
}
